import { ProfileType } from '../models/profile-types.model';

export const PROFILE_TYPES: ProfileType[] = [
  { id: 1, value: 'player', viewValue: 'giocatore', viewValuePlural: 'giocatori' },
  { id: 2, value: 'coach', viewValue: 'allenatore', viewValuePlural: 'allenatori' },
  { id: 3, value: 'team', viewValue: 'squadra', viewValuePlural: 'squadre' },
];
